import { memo, useCallback, useEffect, useState } from "react";
import { Button } from "ui/components/Button/Button";
import { TextField } from "ui/components/TextField/TextField";
import { NumberField } from "ui/components/TextField/NumberField";
import { DatePicker } from "ui/components/DatePicker";
import { ExpenseAppliesTo } from "services/api/finance/expense-types/types";
import ExpenseTypeDropdown from "ui/components/Dropdown/ExpenseTypeDropdown/ExpenseTypeDropdown";
import { VehicleExpenseSearchFilterProps } from "./types";
import { FleetVehicleExpenseSearchFormValues } from "services/api/fleet/vehicles/expenses/types";
import { initialFleetVehicleExpenseSearchForm } from "services/api/fleet/vehicles/expenses/consts";
import { useTranslate } from "helpers";
import {
  useHandleTextFieldChange,
  useHandleDropdownChange,
  useHandleDateChange,
  useHandleNumberFieldChange,
} from "services/forms/hooks";

const VehicleExpenseSearchFilters: React.FC<VehicleExpenseSearchFilterProps> = (
  props
) => {
  const { onAddNew, onSearchChange } = props;
  const { t } = useTranslate();

  const [formValues, setFormValues] =
    useState<FleetVehicleExpenseSearchFormValues>(
      initialFleetVehicleExpenseSearchForm
    );

  useEffect(() => {
    onSearchChange(formValues);
  }, [formValues]);

  const handleTextFieldChange = useHandleTextFieldChange(setFormValues, formValues);
  const handleDropdownChange = useHandleDropdownChange(setFormValues, formValues);
  const handleDateChange = useHandleDateChange(setFormValues, formValues);
  const handleNumberFieldChange = useHandleNumberFieldChange(setFormValues, formValues);

  const handleResetFormClick = useCallback(() => {
    setFormValues(initialFleetVehicleExpenseSearchForm);
  }, []);

  return (
    <div className="flex flex-wrap items-end gap-2 mb-3">
      <div className="w-[150px]">
        <TextField
          type="text"
          name="search"
          value={formValues.search}
          onChange={handleTextFieldChange}
          placeholder="Pretraži..."
          startIcon="/media/icons/search.svg"
          cssClassName="bg-white"
        />
      </div>
      <div className="w-[150px]">
        <ExpenseTypeDropdown
          name="expenseTypeId"
          value={formValues.expenseTypeId}
          onChange={handleDropdownChange}
          placeholder="Vrsta troška"
          appliesTo={ExpenseAppliesTo.VEHICLE}
        />
      </div>
      <div className="w-[120px]">
        <DatePicker
          name="expenseDateFrom"
          label="Datum od - do"
          value={formValues.expenseDateFrom}
          onChange={handleDateChange}
          cssClassName="bg-white"
        />
      </div>
      <div className="w-[120px]">
        <DatePicker
          name="expenseDateTo"
          value={formValues.expenseDateTo}
          onChange={handleDateChange}
          cssClassName="bg-white"
        />
      </div>
      <div className="w-[90px]">
        <NumberField
          name="amountMin"
          label="Iznos od - do"
          placeholder="Iznos od"
          value={formValues.amountMin}
          onChange={handleNumberFieldChange}
          decimals={2}
          cssClassName="bg-white"
        />
      </div>
      <div className="w-[90px]">
        <NumberField
          name="amountMax"
          placeholder="do"
          value={formValues.amountMax}
          onChange={handleNumberFieldChange}
          decimals={2}
          cssClassName="bg-white"
        />
      </div>
      <span
        onClick={handleResetFormClick}
        className="text-xs font-bold cursor-pointer text-gray-500 hover:text-sky-600 pb-2 whitespace-nowrap"
      >
        RESET
      </span>
      <div className="ml-auto">
        <Button
          variant="primary"
          children={t("admin.vehicle.expense.search.add")}
          startIcon="/media/icons/plus.svg"
          onClick={onAddNew}
        />
      </div>
    </div>
  );
};
export default memo(VehicleExpenseSearchFilters);
